import React from 'react';
import PropTypes from 'prop-types';
import Nav from 'react-bootstrap/lib/Nav';
import NavItem from 'react-bootstrap/lib/NavItem'
import styled from 'styled-components';

const TabPaneContainer = styled.div`
    top: 15px;
    position: relative;
    padding: 2rem 1rem 1rem 1rem;
    border-left: 1px solid #ddd;
    border-right: 1px solid #ddd;    
`;

const StyledNav = styled(Nav)`  
  margin-bottom: -15px !important; 
  /* selected tab hover over */ 
  & li.active > a:hover {
    text-decoration: none;
  }
  
  /* all Tab items not selected */
  & li > a {
    background-color: #eeeeee;
    color: #174F87;
  }
  
  /* hover over tabs not selected */
  & li >a:hover {
    background-color: #f5f5f5;
    text-decoration: underline;
    color: #216EBA;
  }
`;

class Tabs extends React.PureComponent {
  state = {activeKey: 0};

  componentWillMount() {
    this.setState({activeKey: this.props.activeKey});
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.activeKey !== nextProps.activeKey) {
      this.setState({activeKey: nextProps.activeKey});
    }
  }

  render() {
    const {children, justified} = this.props;
    const {activeKey} = this.state;
    return (
      <div>
        <StyledNav
          className={justified ? 'nav-justified' : ''}
          bsStyle="tabs"
          activeKey={activeKey}
          onSelect={activeKey => this.setState({activeKey}, () => this.props.onSelect(activeKey))}
        >
          {React.Children.map(children, ({props: {text, disabled, hidden}}, index) => {
              return hidden ? null : (
                <NavItem key={index} eventKey={index} disabled={disabled}>
                  {text}
                </NavItem>
              );
            }
          )}
        </StyledNav>
        <TabPaneContainer className="tab-content">
          {
            React.Children.map(children, (tab, eventKey) => {
              return Boolean(tab.props.hidden) ? null : (
                  <div className={`tab-pane fade in ${eventKey === activeKey ? 'active' : ''}`}>
                    {
                      React.cloneElement(tab, {
                        eventKey,
                        activeKey,
                      })
                    }
                  </div>
                );
              }
            )}
        </TabPaneContainer>
      </div>
    );
  }
}

export const Tab = ({activeKey, eventKey, text, render}) =>
  (activeKey === eventKey) ? render() : null;

Tab.propTypes = {
  text: PropTypes.string.isRequired,
  render: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
};

Tab.defaultProps = {
  disabled: false,
};

Tabs.propTypes = {
  justified: PropTypes.bool,
  activeKey: PropTypes.number,
  onSelect: PropTypes.func,
};

Tabs.defaultProps = {
  activeKey: 0,
  justified: false,
  onSelect: () => {
  },
};

export default Tabs;



// WEBPACK FOOTER //
// ./src/components/Tabs.js